<form *ngIf="workerZoneFormGroup" [formGroup]="workerZoneFormGroup">
    <div class="grid">
        <div class="col-12 input-field">
            <label for="zoneId">Zona</label>
            <p-dropdown [options]="zones" formControlName="zoneId" optionValue="id" [filter]="true"
                (onChange)="onChangeZone($event)" showClear (onFilter)="onSearchZone($event)"
                filterBy="name" optionLabel="name" placeholder="Sin zona" appendTo="body" d-form-field-error />
        </div>
        <div class="col-12 input-field" *ngIf="workerZoneFormGroup.get('zoneId')?.value==null">
            <label for="value" class="mr-1">Código postal</label>
            <input pInputText formControlName="value" id="value" type="text" [required]="true" placeholder="Puedes indicar varios separados por coma (,)" d-form-field-error />
        </div>
        <div class="col-4 input-field">
            <label for="normalServiceAllowed" class="mr-1">Horario normal</label>
            <p-inputSwitch id="normalServiceAllowed" id="normalServiceAllowed" formControlName="normalServiceAllowed"></p-inputSwitch>
        </div>
        <div class="col-4 input-field">
            <label for="guardServiceAllowed" class="mr-1">Horario de guardia</label>
            <p-inputSwitch id="guardServiceAllowed" id="guardServiceAllowed" formControlName="guardServiceAllowed"></p-inputSwitch>
        </div>
        <div class="col-4 input-field" *ngIf="workerZoneFormGroup.get('zoneId')?.value==null">
            <label for="isTemporary" class="mr-1">Temporal</label>
            <p-inputSwitch id="isTemporary" id="isTemporary" formControlName="isTemporary"></p-inputSwitch>
        </div>

        <div class="col-12 input-field">
            <label for="excludedZipCodes" class="mr-1">Códigos postales excluidos</label>
           <!-- <p-autoComplete id="excludedZipCodes" formControlName="excludedZipCodes" [multiple]="true" fluid 
            [suggestions]="allPostaCodesFromSelectedZone" optionLabel="value"></p-autoComplete>-->
            <input pInputText id="excludedZipCodes" formControlName="excludedZipCodes" type="text"  d-form-field-error />
            <small>Separa los códigos postales por comas.</small><br>
        </div>
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete && workerZone.id" icon="pi pi-trash" styleClass="p-button-danger"
            (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>

</form>